//@flow
import React from "react";
import Svg, { Path } from "react-native-svg";

type Props = {
  size: number,
  color: string
};

export default function Ripple({ size, color }: Props) {
  return (
    <Svg viewBox="0 0 16 16" width={size} height={size}>
      <Path
        fill={color}
        d="M11.346 0c2.033 0 3.688 1.624 3.688 3.635 0 2.01-1.655 3.634-3.688 3.634-2.034 0-3.688-1.624-3.688-3.634C7.658 1.624 9.312 0 11.346 0zm0 1.657c-1.126 0-2.032.889-2.032 1.978s.906 1.978 2.032 1.978c1.125 0 2.031-.89 2.031-1.978 0-1.09-.906-1.978-2.031-1.978zm.095 7.074c2.033 0 3.688 1.624 3.688 3.634 0 2.011-1.655 3.635-3.688 3.635-2.033 0-3.688-1.624-3.688-3.635 0-2.01 1.655-3.634 3.688-3.634zm0 1.656c-1.125 0-2.031.89-2.031 1.978 0 1.09.906 1.978 2.031 1.978s2.031-.889 2.031-1.978-.906-1.978-2.031-1.978zM6.878 6.252a3.59 3.59 0 0 1 0 3.646 3.698 3.698 0 0 1-3.19 1.811 3.697 3.697 0 0 1-3.19-1.811 3.59 3.59 0 0 1 0-3.646 3.698 3.698 0 0 1 3.19-1.812c1.314 0 2.53.69 3.19 1.812zm-4.953.84a1.933 1.933 0 0 0 0 1.966 2.042 2.042 0 0 0 1.763.995c.73 0 1.401-.38 1.763-.995a1.933 1.933 0 0 0 0-1.966 2.042 2.042 0 0 0-1.763-.995c-.73 0-1.401.38-1.763.995zm6.89.105l.016 1.656-1.85.019-.016-1.657 1.85-.018zm.199-1.163l1.435.827-.909 1.577-1.435-.826.909-1.578zm1.46 3.13l-1.42.853-.941-1.565 1.42-.854.94 1.566z"
      />
    </Svg>
  );
}
